<template>
    <!--<div class="test">-->
    <div id="ndi-qr">
    </div>
    <!--</div>-->
    
</template>
<script>
export default {
  name: "forget-password-page",
  clientId: "",
  redirectUri: "",
  nonce: "",
  urlnonce: "",
  state: "",
  created() {
    this.axios("get-any-config/SINGPASS")
      .then((response) => {
        this.clientId = response.data.data.SINGPASS_CLIENT_ID
          ? response.data.data.SINGPASS_CLIENT_ID.data
          : "";
        this.redirectUri = response.data.data.SINGPASS_REDIRECT_URI
          ? response.data.data.SINGPASS_REDIRECT_URI.data
          : "";
        this.singpass_url = response.data.data.SINGPASS_URL
          ? response.data.data.SINGPASS_URL.data
          : "";
        if (this.clientId && this.redirectUri && this.singpass_url) {
          const genRanHex = (size) =>
            [...Array(size)]
              .map(() => Math.floor(Math.random() * 16).toString(16))
              .join("");

          let nonce = "412557b5-c6e8-43b5-ad8c-" + genRanHex(12);
          let state = "f67bbc97-6804-4c77-b1ea-" + genRanHex(12);
          const singpass_url = this.singpass_url;
          const client_id = this.clientId;
          const auth_url = singpass_url + "/auth";
          const scope = "openid";
          const response_type = "code";
          const redirect_uri = this.redirectUri;
          const url = `${auth_url}?scope=${scope}&response_type=${response_type}&redirect_uri=${redirect_uri}&nonce=${nonce}&client_id=${client_id}&state=${state}`;
          window.location.href = url;
        } else {
          console.log("DB");
          this.$message.error("Something went wrong.");
        }
      })
      .catch(() => {
        console.log("API");
        this.$message.error("Something went wrong.");
      });
  },
};
</script>


